import { getSummary, getTableData, getFilteredTableData, getExportData, getIdentifiers } from "../../api/gsIntg";
import { csvmaker } from "../../helper/utils";
import { DLRDashboard } from "@gs/gs-integration-component";
import { DLRColumns, DLRSummaryColumns, testAccounts } from "../../utils/constants";
// orgId/org are passed down as props from Widget; no direct Bloomreach messaging here.
const Dashboard = ({ orgId, org }) => {
    const limit = 10;

    const filterWabaNumbers = (channels) => {
        
        let wabaData = []
        const entChannels = channels?.filter((o) => o.channelType == 'enterprise')
        entChannels?.forEach(element => {
            wabaData.push({
                label: element.whatsappNo,
                value: element.whatsappNo
            })
        });
        const uniqueNumbers = wabaData.filter((value, index, self) => 
            index === self.findIndex((t) => (
              t.value === value.value 
            ))
          );
        return uniqueNumbers
    }
    const handleCallback = async (data, type) => {
        let summary,  identifiers;
        const WabaNumber = testAccounts.includes(data?.channel) ? 'TESTSM' : data.channel
        switch(type) {
            case "channelChange":
                
                summary = await getSummary(orgId, data, WabaNumber);
                identifiers = await getIdentifiers(orgId, data?.dateRange?.startDate, data?.dateRange?.endDate, WabaNumber);
                const tableData = await getTableData(orgId, data, WabaNumber, 0, limit);
                return {summary, programs: identifiers, tableData};
            case "programChange":
                const programFilteredTableData = await getFilteredTableData(orgId, data, WabaNumber, limit);
                return programFilteredTableData;
            case "filterChange":
                const filteredTableData = await getFilteredTableData(orgId, data, WabaNumber, limit);
                return filteredTableData;
            case "export":
                const filteredData = await getExportData(orgId, data, WabaNumber);
                const csvData = csvmaker(filteredData);
                const blob = new Blob([csvData], { type: 'text/csv' });
                return blob;
            default:
                break;
        }
    }
    return(
        <>
            {org?.channels?.length > 0 ? <DLRDashboard
             columns={DLRColumns}
             channels={filterWabaNumbers(org?.channels)} 
             callbackMethod={handleCallback} 
             summaryColumns={DLRSummaryColumns}
             meta={{
                channel: 'Choose WABA',
                program: 'Programs'
             }
             }/> : <p>No accounts found</p>}
        </>
    )
}
export default Dashboard;
